import React from "react"
import dayjs, { Dayjs } from "dayjs"
import { ICustomFieldTemplate } from "../../entities/job/interface"
import { LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { Box, Typography, ThemeProvider } from "@mui/material"
import { theme } from "../../styles/theme"
import { TimePicker } from "@mui/x-date-pickers/TimePicker"
import AccessTimeIcon from "@mui/icons-material/AccessTime"

interface Props {
    field: ICustomFieldTemplate
    value: Dayjs | null
    error?: string
    onChange: (id: string, value: Dayjs | null) => void
    isEditable: boolean
}

const TimeComponent: React.FC<Props> = ({ field, value, error, onChange, isEditable }) => {
    const [openTimePicker, setOpenTimePicker] = React.useState(false)
    return (
        <ThemeProvider theme={theme}>
            <Box width={"100%"} display={"flex"} flexDirection={"column"}>
                <Box
                    width={"100%"}
                    padding={"10px"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"space-between"}
                    bgcolor={"#027BBA"}
                    borderRadius={"10px"}
                >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <TimePicker
                            ampm={true}
                            open={openTimePicker}
                            value={value === null ? null : dayjs(value, "HH:mm")}
                            onChange={(newValue) => onChange(field.customFieldTemplateId, newValue)}
                            onClose={() => setOpenTimePicker(false)}
                            disabled={!isEditable}
                            slotProps={{
                                textField: {
                                    error: !!error,
                                    size: "small",
                                    fullWidth: true,
                                    inputProps: {
                                        style: {
                                            cursor: isEditable ? "pointer" : "not-allowed",
                                        },
                                    },
                                    onClick: () => setOpenTimePicker(true),
                                },
                                actionBar: {
                                    actions: ["clear", "today"],
                                },
                            }}
                            sx={{
                                fontSize: "18px",
                                color: "white",
                                "& .MuiInputBase-root": {
                                    color: "white",
                                    height: 20,
                                    fontSize: "15px",
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "none",
                                    border: "0px",
                                },
                                "& .MuiPickersModal-root": {
                                    backgroundColor: "#F0F0F0",
                                    color: "white",
                                    width: "100%",
                                },
                                "& .MuiOutlinedInput-root .MuiInputBase-input::placeholder": {
                                    color: "white",
                                },
                                "& .MuiInputAdornment-root": {
                                    display: "none",
                                },
                            }}
                        />
                    </LocalizationProvider>
                    <AccessTimeIcon
                        style={{
                            color: isEditable ? "#FFFFFF" : "#A0A0A0", // Change color if not editable
                            cursor: isEditable ? "pointer" : "not-allowed", // Change cursor style if not editable
                        }}
                        onClick={() => {
                            if (!isEditable) return
                            setOpenTimePicker(true)
                        }}
                    />
                </Box>
                <Typography variant="caption" color="error" fontSize={"15px"}>
                    {error}
                </Typography>
            </Box>
        </ThemeProvider>
    )
}

export default TimeComponent
